import LegalPage from './LegalPage'
import { REFUND_POLICY } from './legal'

export default function RefundPolicyPage() {
  return <LegalPage {...REFUND_POLICY} />
}
